<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        :options="options"
        :error="error"
        :loading="loading"
        emit-value
        map-options
    >
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
    tipo: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([
    { label: "CONSUMIDOR FINAL", value: "F" },
    { label: "DEUDORES DEL EXTERIOR", value: "E" },
    { label: "EXENTO", value: "X" },
    { label: "MONOTRIBUTISTA", value: "M" },
    { label: "NO SUJETO", value: "S" },
    { label: "RESPONSABLE INSCRIPTO", value: "I" },
    { label: "RESPONSABLE NO INSCRIPTO", value: "N" },
]);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
</script>
